import { getCookie } from './cookies';

export const track = (eventName: string, traits?: object) => {
    const isAnalyticsConsentEnabled = getCookie('analyticsConsent') === 'true';

    // @ts-ignore
    if (window.analytics && isAnalyticsConsentEnabled) {
        // @ts-ignore
        analytics.track(eventName, traits);
    }
};
